import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

interface ResponsiveProps {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?:boolean;
}


export const NavLinksWrapper = styled.div<ResponsiveProps>`
  display: flex;
  background-color: ${({theme })=> theme.colors.primary};
  justify-content: space-evenly;
  text-align: center;
  vertical-align: middle;
  padding: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '0 10px 0 10px' : isMobileMedium ? '0 10px 0 10px' : isMobileBig ? '0 15px 0 15px' : isMiniNotebook ? '0 40px 0 40px' : '0 100px 0 100px'};
  height: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '80px' : isMobileMedium ? '80px' : isMobileBig ? '55px' : isMiniNotebook ? '55px' : '60px'};
  display:${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? 'grid' : isMobileMedium ? 'grid' : isMobileBig ? 'grid' : isMiniNotebook ? 'flex' : 'flex'};
  grid-column-gap:${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '2px' : isMobileMedium ? '2px' : isMobileBig ? '2px' : isMiniNotebook ? '0px' : '0px'};
  grid-row-gap: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '2px' : isMobileMedium ? '2px' : isMobileBig ? '2px' : isMiniNotebook ? '0px' : '0px'};
  grid-template-columns: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '1fr 1fr 1fr' : isMobileMedium ? '1fr 1fr 1fr' : isMobileBig ? '1fr 1fr 1fr' : isMiniNotebook ? 'none' : 'none'};
`;


export const StyledNavLink = styled(NavLink)<ResponsiveProps>`
  text-decoration: none;
  margin: auto auto;
  font-weight: bold;
  color: #edebdd;
  /*height: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '18px' : isMobileMedium ? '34px' : isMobileBig ? '36px' : isMiniNotebook ? '40px' : '40px'};*/
  font-size: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '16px' : isMobileMedium ? '17px' : isMobileBig ? '18px' : isMiniNotebook ? '20px' : '25px'};
  text-align: center;
  
  
  transition: opacity 0.3s ease;

  &:hover { 
    opacity: 0.7;
  }

  &:active {
    opacity: 0.52;
  }

  &.active {
    color: ${({ theme }) => theme.colors.text};
  }
`;